import SummaryPanel from "./SummaryPanel";

export default SummaryPanel;
